<template>
  <portlet
          :icon="'fad fa-edit'"
          :title="'Vacature gegevens'"
          :footer="true"
  >
    <template slot="portletBody">
      <div class="row">
        <div class="form-group col-xl-4">
          <label for="vacancy-name">Naam</label>
          <input name="Naam"
                 id="vacancy-name"
                 type="text"
                 class="form-control"
                 v-validate="'required'"
                 v-model="vacancy.name"
          >
          <span v-if="errors.first('Naam')" class="small text-danger">Dit veld is verplicht</span>
        </div>
        <div class="form-group col-xl-4">
          <label for="vacancy-customer">Bedrijf</label>
          <v-select
                  v-validate="'required'"
                  :options="getCustomers"
                  :selectOnTab="true"
                  @input="setDepartmentAndLocation"
                  label="name"
                  name="customer"
                  v-model="customer"
                  :class="{ 'is-invalid': errors.has('customer')}"
          />
          <input
                  v-model="customer"
                  v-show="false"
                  v-validate="'required'"
                  name="customer"
          />
          <span v-if="errors.first('customer')" class="small text-danger">Dit veld is verplicht</span>
        </div>

        <div class="form-group col-xl-4" v-if="customer">

          <label for="vacancy-customer">Locatie</label>
          <input
              v-model="customer.location"
              :disabled="true"
              class="form-control"
              name="customerLocation"
          />
        </div>

        <div class="form-group col-xl-4" v-if="customer">
          <label for="vacancy-customer">Vestiging</label>
          <div class="form-group inline-checkboxes">
            <div
                class="custom-control custom-checkbox"
                v-for="department in getDepartments"
                :key="department.value"
            >
              <input
                  v-validate="'required'"
                  v-model="vacancy.departments"
                  :value="department.value"
                  :disabled="department.forced"
                  name="departments"
                  type="checkbox"
                  :id="department.value"
                  class="custom-control-input"
              />
              <label class="custom-control-label" :for="department.value">{{department.value}}</label>
            </div>
            <span v-if="errors.first('departments')" class="small text-danger">Dit veld is verplicht</span>
          </div>

        </div>
        <div class="form-group col-xl-4 salary-input">
          <label for="vacancy-salaryFrom">Bruto salarisindicatie in euro's per/uur</label>
          <div class="row no-gutters">
            <div class="col-6">
              <input v-validate="'required'"
                     name="vacancy-salaryFrom"
                     id="vacancy-salaryFrom"
                     type="number"
                     class="form-control width-half"
                     v-model="vacancy.salaryFrom"
                     placeholder="Minimaal"
              >
              <span v-if="errors.first('vacancy-salaryFrom')" class="small text-danger">Dit veld is verplicht.</span>
            </div>
            <div class="col-6">
              <input v-validate="'required'"
                     name="vacancy-salaryTo"
                     id="vacancy-salaryTo"
                     type="number"
                     class="form-control width-half"
                     v-model="vacancy.salaryTo"
                     placeholder="Maximaal"
              >
              <span v-if="errors.first('vacancy-salaryTo')" class="small text-danger">Dit veld is verplicht.</span>
            </div>
          </div>
        </div>
        <div class="form-group col-xl-4 hour-input">
          <label for="vacancy-salaryFrom">Werkuren</label>
          <div class="row no-gutters">
            <div class="col-6">
              <v-select
                  :options="workingHours"
                  :selectOnTab="true"
                  label="name"
                  @input="setDepartmentAndLocation"
                  v-model="vacancy.workHours"
                  :class="{ 'is-invalid': errors.has('customer')}"
              />
              <span v-if="errors.first('vacancy-salaryFrom')" class="small text-danger">Dit veld is verplicht.</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-lg-6">
          <label>Wat ga je doen als?</label>
          <tiptap-editor
                  v-model="vacancy.description"
                  :content="vacancy.description"/>
        </div>
        <div class="form-group col-lg-6">
          <label>Introductie</label>
          <tiptap-editor
              v-model="vacancy.introduction"
              :content="vacancy.introduction"/>
        </div>

      </div>
      <div class="row">
        <div class="form-group col-lg-6">
          <label>Wie ben jij?</label>
          <tiptap-editor
              v-model="vacancy.descExpect"
              :content="vacancy.descExpect"/>
        </div>
        <div class="form-group col-lg-6">
          <label>Wat bieden wij jou?</label>
          <tiptap-editor
                  v-model="vacancy.descOffer"
                  :content="vacancy.descOffer"/>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label>Sector</label>
          <div class="form-group inline-radios">
            <div :key="sector" class="custom-control custom-radio" v-for="sector in sectors">
              <input :value="sector"
                     type="radio"
                     :id="sector"
                     name="known"
                     class="custom-control-input"
                     v-validate="'required'"
                     v-model="vacancy.sector"
              >
              <label class="custom-control-label" :for="sector">{{ sector }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="vacancy.sector === 'Anders'">
        <div class="col-12">
          <v-select
              taggable
              v-model="vacancy.sectorOther"
              :options="knownFromOthers"
              :createOption="createOptionsKnownFrom"
              class="form-group"
              :selectOnTab="true"
          ></v-select>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label>Ploegen</label>
          <div class="form-group inline-checkboxes">
            <div
                    class="custom-control custom-checkbox"
                    v-for="shift in shiftOptions"
                    :key="shift.index"
            >
              <input
                      v-validate="'required'"
                      v-model="vacancy.shifts"
                      :value="shift"
                      name="shift"
                      type="checkbox"
                      :id="shift"
                      class="custom-control-input"
              />
              <label class="custom-control-label" :for="shift">{{shift}}</label>
            </div>
            <span v-if="errors.first('shift')" class="small text-danger">Dit veld is verplicht</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label>Ervaringen</label>
          <div class="form-group inline-checkboxes">
            <div class="custom-control custom-checkbox"
                 v-for="(experience,index) in getExperiences"
                 :key="'experience-'+index">
              <input v-model="vacancy.experiences"
                     :value="experience.name"
                     type="checkbox"
                     :id="experience.id"
                     class="custom-control-input"
                     name="experiences-name"
                     v-validate="'required'"
              >
              <label class="custom-control-label"
                     :for="experience.id">{{experience.name}}</label>
            </div>
            <div class="custom-control custom-checkbox">
              <input v-model="vacancy.experiences"
                     value="Anders"
                     type="checkbox"
                     id="experience-other"
                     class="custom-control-input">
              <label class="custom-control-label" for="experience-other">Anders</label>
            </div>
            <span v-if="errors.first('experiences-name')" class="small text-danger">Dit veld is verplicht</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label>Rijbewijs</label>
          <div class="form-group inline-checkboxes">
            <div
                    class="custom-control custom-checkbox"
                    v-for="driverLicense in driverLicenseOptions"
                    :key="driverLicense.index"
            >
              <input
                      v-model="vacancy.driverLicense"
                      :value="driverLicense"
                      type="checkbox"
                      :id="driverLicense"
                      class="custom-control-input"
              />
              <label class="custom-control-label"
                     :for="driverLicense">{{driverLicense}}</label>
            </div>
          </div>
        </div>
      </div>
      <vacancy-contact-person v-model="vacancy.responsibleUser"></vacancy-contact-person>
      <div class="row">
        <div class="form-group col">
          <label for="vacancy-otherNotes">Overige opmerkingen (intern)</label>
          <textarea
                  rows="4"
                  id="vacancy-otherNotes"
                  name="vacancy-otherNotes"
                  class="form-control"
                  v-model="vacancy.otherNotes"
          ></textarea>
        </div>
      </div>
      <div class="form-group inline-checkboxes">
        <div class="custom-control custom-checkbox">
          <input
                  v-model.number="vacancy.apiActive"
                  :value="1"
                  name="shift"
                  type="checkbox"
                  id="vacancyApiActive"
                  class="custom-control-input"/>
          <label class="custom-control-label" for="vacancyApiActive">Actief op website</label>
        </div>
      </div>
    </template>
    <div slot="portletFooter" class="col-12 text-right">
      <button @click="saveVacancy" type="submit" class="btn btn-primary">
        <i class="fal fa-save mr-2"></i> Opslaan
      </button>
    </div>
  </portlet>
</template>

<script>
  import {mapGetters} from 'vuex';
  import vacancyContactPerson from './vacancyContactPerson';
  import {defaultContactPerson, workfixEmployeesOf} from '@/utils/vacancyContact';


  export default {
    props: ['id', 'vacancy'],
    components: {vacancyContactPerson},
    data() {
      return {
        renderedComponent: true,
        vacancyCopy: null,
        selectedFile: null,
        sectors: ['Productie', 'Logistiek', 'Anders'],
        workingHours: [4, 8, 12, 16, 20, 24, 28, 32, 36, 40, "Fulltime"],
        driverLicenseOptions: ['Brommer AM', 'Auto B', 'Vrachtwagen C', 'Vrachtwagen CE', 'Trekker T'],
        experienceOptions: ['Heftruck 3w', 'Heftruck 4w', 'Reachtruck', 'Combitruck', 'EPT', 'Dubbele vorken', 'Hoogwerker', 'Scanner', 'SAP', 'Stukgoed', 'Zakgoed'],
        shiftOptions: ['Dagdienst', 'Versch. dagdienst', 'Nachtdienst', '2 ploegen', '3 ploegen', '4 ploegen', '5 ploegen', 'Vakantiekracht'],
        customer: ''
      };
    },
    methods: {
      setDepartmentAndLocation() {
        if(this.customer) {
          const departments = this.getDepartments;
          const forcedDepartments = departments.length === 1 ? departments : _.filter(departments, { 'forced': true });
          this.vacancy.departments = _.map(forcedDepartments, 'value');
          this.vacancy.location = this.customer.location;
        }
      },
      renderComponent() {
        this.renderedComponent = false;

        this.$nextTick(() => {
          this.renderedComponent = true;
        });
      },

      /**
       * Vacancies from before the contact person existed (no field at all) default to their creator. A contact person
       * that was cleared on purpose is null and stays cleared. The default goes into the copy as well, so it does not
       * count as an unsaved change. Does nothing while the users have not loaded yet; the getUsers watcher retries.
       */
      applyDefaultContactPerson() {
        if (this.vacancy.responsibleUser !== undefined) {
          return;
        }

        const employees = workfixEmployeesOf(this.getUsers, this.getRoles, this.getUserData.selectedDepartment);
        if (!employees.length) {
          return;
        }

        const person = defaultContactPerson(employees, this.vacancy.createdBy);
        this.$set(this.vacancy, 'responsibleUser', person);
        if (this.vacancyCopy) {
          this.vacancyCopy.responsibleUser = person ? {...person} : null;
        }
      },

      saveVacancy() {
        this.$validator.validate().then(result => {
          if(result) {
            this.$emit('unsavedChanges', false);
            let vacancy = this.vacancy
            let vacancyData = {
              lastEditedBy: this.$store.getters.getUserData,
              id: this.vacancy.id,
              name: this.vacancy.name,
              customerId: this.customer.id,
              ...vacancy
            };

            if(this.selectedFile == null) {
              vacancyData.picture = '';
            } else {
              vacancyData.picture = this.selectedFile.name;
            }

            this.$store.dispatch('vacancies/set', vacancyData).then(() => {
              this.$toasted.global.successRequest({
                message: 'Vacature aangepast'
              });
            }).catch(() => {
              this.$toasted.global.failedRequest();
            });
          } else {
            this.$toasted.global.failedFormRequest();
          }
        });
      }
    },
    computed: {
      ...mapGetters('customers', ['getCustomer', 'getCustomers']),
      ...mapGetters('experiences', ['getExperiences']),
      ...mapGetters(['getUserData']),
      ...mapGetters('users', ['getUsers']),
      ...mapGetters('roles', ['getRoles']),
      getDepartments() {
        const departments = this.getCustomer(this.customer.id).departments;
        if (!departments || !departments.length) {
          return [{key: '', value: this.getCustomer(this.customer.id).location, forced: true}];
        } else {
          return  departments;
        }
      }
    },

    watch: {
      vacancy: {
        handler: function (val) {
          this.$emit('unsavedChanges', JSON.stringify(val) !== JSON.stringify(this.vacancyCopy));
        },
        deep: true
      },
      // The users load late in initApp, so on a fresh page load the default may only be known once they arrive.
      getUsers() {
        this.applyDefaultContactPerson();
      }
    },
    created() {
      this.applyDefaultContactPerson();

      this.vacancyCopy = JSON.parse(JSON.stringify(this.vacancy));

      this.customer = this.getCustomer(this.vacancy.customerId);
      
      if(this.customer) {
        const departments = this.getDepartments;
        const forcedDepartments = departments.length === 1 ? departments : _.filter(departments, { 'forced': true });
        if(!this.vacancy.departments || !this.vacancy.departments.length) {
          this.vacancy.departments = forcedDepartments;
        }
        if(!this.vacancy.location) {
          this.vacancy.location = this.customer.location;
        }
      }
    }
  };
</script>